import { type FC } from "react";

import { type SpecApprovalState } from "../../../../gql-generated/types";
import { HeaderItem, LensListHeaderSection } from "../../../../shared/components";
import { DateModifiedLabel, NameLabel } from "../../messages.generated";
import { SortBy, type SortDirection } from "../sort";

import { ApiStatusHeader } from "./ApiStatusHeader";
import { dateWidth, dropdownWidth, idWidth, nameWidth } from "./HeaderWidth.style";
import { SortableHeaderItem } from "./SortableHeaderItem";
import { type OnSort, type StatusFilter } from "./models";

interface ApisListHeader {
    onSort: OnSort;
    sortDirection: SortDirection;
    sortBy: SortBy;
    onStatusFilter: StatusFilter;
    statusFilters: Set<SpecApprovalState>;
}

export const ApisListHeader: FC<ApisListHeader> = ({
    onSort,
    onStatusFilter,
    statusFilters,
    sortBy,
    sortDirection,
}) => {
    return (
        <LensListHeaderSection>
            <SortableHeaderItem
                sortBy={sortBy}
                itemSortByKey={SortBy.Name}
                sortDirection={sortDirection}
                onSort={onSort}
                className={nameWidth}
            >
                <NameLabel />
            </SortableHeaderItem>
            <HeaderItem className={idWidth}>ID</HeaderItem>
            <SortableHeaderItem
                sortBy={sortBy}
                itemSortByKey={SortBy.Date}
                sortDirection={sortDirection}
                onSort={onSort}
                className={dateWidth}
            >
                <DateModifiedLabel />
            </SortableHeaderItem>
            <ApiStatusHeader statusFilters={statusFilters} onStatusFilter={onStatusFilter} />
            <HeaderItem className={dropdownWidth} />
        </LensListHeaderSection>
    );
};
